<!-- 合作伙伴 -->
<template>
  <div id="CooperativePartner">
    <div class="title">
      <div class="t">T</div>
      <div class="content">
        <p>合作伙伴</p>
        <p>Cooperative Partner</p>
      </div>
      <div class="line"></div>
    </div>
    <el-row :gutter="60">
      <el-col :span="6"
        ><a target="_blank" href="https://www.huize.com/"
          ><div class="img-item">
            <img
              id="huize"
              src="../../assets/images/logo/huize.png"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="http://www.ciming.com/"
          ><div class="img-item">
            <img
              id="ciming"
              src="../../assets/images/logo/ciming.png"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="http://www.jjklife.com/"
          ><div class="img-item">
            <img
              id="jijiankang"
              src="../../assets/images/logo/jijiankang.png"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="http://www.childrenshospital.org/"
          ><div class="img-item">
            <img
              id="boston"
              src="../../assets/images/logo/boston.png"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="http://www.pumch.cn/index.html"
          ><div class="img-item">
            <img
              id="xiehe"
              src="../../assets/images/logo/xiehe.jpg"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="https://www.mayoclinic.org/"
          ><div class="img-item">
            <img
              id="mayo"
              src="../../assets/images/logo/mayo.png"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="https://huashan.org.cn/"
          ><div class="img-item">
            <img
              id="huashan"
              src="../../assets/images/logo/huashan.jpg"
              alt=""
            /></div></a
      ></el-col>
      <el-col :span="6"
        ><a target="_blank" href="http://www.301hospital.com.cn/"
          ><div class="img-item">
            <img
              id="sanlingyao"
              src="../../assets/images/logo/301.png"
              alt=""
            /></div></a
      ></el-col>
    </el-row>
  </div>
</template>

<script>
// import HomeTitle from "../home/HomeTitle";
export default {
  name: "CooperativePartner",
  data() {
    return {
      content: { Chinese: "合作伙伴", English: "Cooperative Partner" }
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#CooperativePartner {
  width: 75%;
  margin: $margin;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .img-item {
    height: 135px;
    /*border: 1px solid #eeeeee;*/
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #huize {
    width: 160px;
    height: 136px;
  }
  #ciming {
    width: 153px;
    height: 125px;
  }
  #jijiankang {
    width: 63px;
    height: 99px;
  }
  #boston {
    width: 128px;
    height: 66px;
  }
  #xiehe {
    width: 120px;
    height: 120px;
  }
  #mayo {
    width: 92px;
    height: 99px;
  }
  #huashan {
    width: 120px;
    height: 120px;
  }
  #sanlingyao {
    width: 153px;
    height: 120px;
  }
}
.title {
  width: 100%;
  margin: 0 auto;
  display: flex;
  position: relative;
  .t {
    font-size: 50px;
    font-weight: 800;
    color: #3490ec;
  }
  .content {
    color: #3490ec;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: left;
    p:nth-child(2) {
      margin-bottom: 5px;
    }
  }
  .line {
    width: 80%;
    height: 100%;
    border-bottom: 1px solid #479aed;
    position: absolute;
    right: 0;
    bottom: 11%;
  }
}
</style>
